import { createAsyncThunk } from "@reduxjs/toolkit";
import { snackWrapper } from "helpers";
import { RootState } from "toolkit/store";
import { checkCompletingReferences } from "toolkit/references/references.thunks";
import { usersAPI } from "libs/apiClient/Users";
import { LongUserListingResponse } from "libs/apiClient/data-contracts";
import { userAPI } from "libs/apiClient/User";
import { roleAPI } from "libs/apiClient/Role";

export const getUsers = createAsyncThunk(
	"usersSlice/getUsers",
	async (
		// body: {
		// 	data: any
		// 	change: boolean
		// },
		body: {
			searchValue?: string | number;
			filter_active?: boolean;
			filter_value?: string;
			filter_column?: string;
			change?: any;
			select?: any;
		},
		{ rejectWithValue, dispatch },
	) => {
		try {
			const { select } = body;

			// let url;
			let response: LongUserListingResponse;
			if (select) {
				response = await usersAPI.longUnboundList({ page: 1, num: 999999 }).then(({ data }) => data);
			} else {
				response = await usersAPI.longList({ page: 1, num: 999999 }).then(({ data }) => data);
			}

			// const res = {
			// 	...(await $api<IUser[]>(url, { params })).data,
			// 	change: body.change,
			// };

			dispatch(checkCompletingReferences());

			return { ...response, change: body.change };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const signUpUser = createAsyncThunk(
	"usersSlice/signUpUser",
	async ({ user, close }: { user: any; close: () => void }, { rejectWithValue }) => {
		try {
			const newUser = await userAPI
				.userCreate({
					email: user.email,
					firstName: user.firstName,
					lastName: user.lastName,
					middleName: user.middleName,
					organization: user.organization,
					password: user.password,
				})
				.then(({ data }) => data);
			// const newUser = (
			// 	await $api.post<IUser>(`/user`, {
			// 		email: user.email,
			// 		firstName: user.firstName,
			// 		lastName: user.lastName,
			// 		middleName: user.middleName,
			// 		organization: user.organization,
			// 		password: user.password,
			// 	})
			// ).data;

			close();
			return newUser;
		} catch (e: any) {
			return rejectWithValue({
				message: "Пользователь с таким email уже существует",
				status: e.response.status,
			});
		}
	},
);

export const changeActiveFilter = createAsyncThunk(
	"usersSlice/changeActiveFilter",
	async ({ params, item, setParams, fetching }: any, { rejectWithValue, getState }) => {
		try {
			// params.change = false;
			const { filter_column, filter_value, filter_active, ...restParams } = params;

			const state: any = (getState() as RootState).users;
			const newFilters: typeof state.usersFilters = {
				status: [],
				role: [],
				position: [],
			};

			let key: keyof typeof state.users;
			for (key in state.usersFilters) {
				let arr = state.usersFilters[key];
				if (key === item.column) {
					newFilters[key] = [...arr].map((_) =>
						_.id === item.id
							? {
									..._,
									active: true,
							  }
							: { ..._, active: false },
					);
				} else {
					newFilters[key] = [...arr].map((_) => (_.id === 0 ? { ..._, active: true } : { ..._, active: false }));
				}
			}

			const st = newFilters.status.find((_: any) => _.active);
			const pos = newFilters.position.find((_: any) => _.active);
			const role = newFilters.role.find((_: any) => _.active);
			let par: any = {};

			if (st && st.column) {
				if (st.id !== 0) {
					par = { filter_column: st.column, filter_value: st.name };
				}
			}
			if (role && role.column) {
				if (role.id !== 0) {
					par = { filter_column: role.column, filter_value: role.name };
				}
			}
			if (pos && pos.column) {
				if (pos.id !== 0) {
					par = { filter_column: pos.column, filter_value: pos.name };
				}
			}

			// if ( filter_active ) {
			await setParams((prevState: any) => {
				const { filter_column, filter_value, ...restPrevState } = prevState;
				return {
					...restPrevState,
					...restParams,
					...(filter_active && { filter_active }),
					...par,
				};
			});
			// await fetching()

			// getUsers( {
			// 		...restParams,
			// 		filter_active,
			// 		...( isEmpty( par ) ? {} : { ...par } ),
			// 	} )
			// );
			// } else {
			// 	dispatch(
			// 		getUsers( {
			// 			...restParams,
			// 			filter_active,
			// 			...( isEmpty( par ) ? {} : { ...par } ),
			// 		} )
			// 	);
			// }
			return newFilters;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getUserRoles = createAsyncThunk(
	"usersSlice/getUserRoles",
	async (body: { userId: string; query?: string }, { rejectWithValue }) => {
		try {
			return await userAPI
				.roleListDetail(+body.userId, {
					page: 1,
					num: 999999,
					query: body.query,
				})
				.then((r) => r.data);
			// return (await $api.get(`/user/${body.userId}/role/list?page=1&num=999999&query=${body.query}`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const setAdmin = createAsyncThunk("usersSlice/setAdmin", async (userId: string, { rejectWithValue }) => {
	try {
		return await userAPI.roleAdminDetail(+userId).then((r) => r.data);
		// return (await $api.get(`/user/${userId}/role/admin`)).data;
	} catch ({ message }) {
		return rejectWithValue(message);
	}
});

export const unsetAdmin = createAsyncThunk(
	"usersSlice/unsetAdmin",
	async (userId: string | undefined, { rejectWithValue }) => {
		try {
			return await userAPI.roleAdminDelete(+userId!).then((r) => r.data);
			// return (await $api.delete(`/user/${userId}/role/admin`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getRoles = createAsyncThunk("usersSlice/getRoles", async (_, { rejectWithValue }) => {
	try {
		return await roleAPI.listList({ page: 1, num: 9999999 }).then((r) => r.data);
		// return (await $api.get(`/role/list?page=1&num=9999999`)).data;
	} catch ({ message }) {
		return rejectWithValue(message);
	}
});

export const setRole = createAsyncThunk(
	"usersSlice/setRole",
	async (
		{
			userId,
			organizationId,
			role,
		}: {
			userId: string | undefined;
			organizationId: string;
			role: { id: number; name: string; system?: "DEFAULT" | "CATEGORIZATION" | undefined; users: number };
		},
		{ rejectWithValue },
	) => {
		try {
			if (role.name === "Не задано") {
				await userAPI
					.roleUpdate(+userId!, {
						assign: {},
						unassign: [+role.id],
					})
					.then(({ data }) => data);
				// res = (
				// 	await $api.put(`/user/${userId}/role`, {
				// 		assign: {},
				// 		unassign: [role.id],
				// 	})
				// ).data;
			} else {
				await userAPI
					.roleUpdate(+userId!, {
						assign: { [organizationId]: +role.id },
						unassign: [],
					})
					.then(({ data }) => data);
				// res = (
				// 	await $api.put(`/user/${userId}/role`, {
				// 		assign: { [organizationId]: role.id },
				// 		unassign: [],
				// 	})
				// ).data;
			}

			snackWrapper("success", "Роль успешно задана");

			return { organizationId, role };
		} catch ({ message }) {
			snackWrapper("error", "Не удалось задать роль");

			return rejectWithValue(message);
		}
	},
);

export const addUser = createAsyncThunk(
	"usersSlice/addUser",
	async (
		body: {
			email: string;
			password: string;
			name: string;
			surname: string;
			patronymic: string;
		},
		{ rejectWithValue, dispatch },
	) => {
		try {
			const profile = await userAPI
				.userCreate({
					firstName: body.name,
					middleName: body.patronymic,
					lastName: body.surname,
					email: body.email,
					password: body.password,
				})
				.then(({ data }) => data);
			// const profile = (
			// 	await $api.post<IProfile>(`/user`, {
			// 		firstName: body.name,
			// 		middleName: body.patronymic,
			// 		lastName: body.surname,
			// 		email: body.email,
			// 		password: body.password,
			// 	})
			// ).data;
			dispatch(getUsers({}));

			snackWrapper("success", "Пользователь успешно добавлен");

			return profile;
		} catch ({ message }) {
			snackWrapper("error", "Не удалось добавить пользователя");

			return rejectWithValue(message);
		}
	},
);
